module.exports = __webpack_public_path__ + "images/Instruments.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/Instruments.png
// module id = 129
// module chunks = 0 1